export default __webpack_public_path__ + "static/media/ic_bnb_40.dd380c10.svg";